import CityPageTemplate from "../hawaii-city/CityPageTemplate";
import { lahainaConfig } from "./data";

export default function Page() {
  return <CityPageTemplate config={lahainaConfig} />;
}